var BlockView = require('views/block/base-block-view');
var InputCollectionView = require('views/block/input/input-collection-view');
var FeedbackService = require('services/feedback-service');
var Feedback = require('models/feedback');

/**
 * @View
 * 
 * @name input
 * @type block
 * @desciption Input Block
 * @content 
 *  @contains @array_of 'inputs' with:
 *    @prop @advanced wrapper_class type={string} title="Wrapper Class" description="e.g., 'choice-card'"
 *    @contains @advanced helptext with:
 *      @prop text  type={string} title="Input Help Text"
 *      @prop [position] type={string} title="Input Help Text Position"
 *        "top"
 *        "bottom"
 *    @end
 *    @prop [type] type={string} title="Input Type" default="text"
 *      "button-radio"
 *      "text"
 *      "textarea"
 *      "select"
 *      "radio"
 *      "checkbox"
 *      "number"
 *      "toggle"
 *      "date"
 *    @prop id type={string} title="Input ID"
 *  @end
 */
var InputView = BlockView.extend({
  regions: {
    'inputs': '.inputs'
  },
  load: function() {
    var inputCollectionView = new InputCollectionView({
      region: 'inputs',
      collection: new Chaplin.Collection(this.model.get('inputs'))
    });
    this.subview('inputs', inputCollectionView);

    this.listenTo(inputCollectionView.collection, 'change', (e) => {
      var match = inputCollectionView.collection.reduce((result, item) => {
        result[item.get('id')] = item.get('value');
        return result;
      }, {});
      var feedback = FeedbackService.matchFeedback(this.model.get('feedbacks'), match);
      if(feedback) {
        if(document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        var feedbackModel = new Feedback(feedback);
        FeedbackService.renderFeedback(feedbackModel);
      }
    });
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = InputView;
